import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { QuestionnaireGroupsEffects } from './state/effects';
import { CONFIGURABLE_QUESTIONNAIRES_FEATURE_KEY, configurableQuestionnairesReducer } from './state/reducers';

/**
 * DataAccess Configurable Questionnaires Module
 */
@NgModule({
    imports: [
        StoreModule.forFeature(CONFIGURABLE_QUESTIONNAIRES_FEATURE_KEY, configurableQuestionnairesReducer),
        EffectsModule.forFeature([QuestionnaireGroupsEffects]),
    ],
})
export class DataAccessConfigurableQuestionnairesModule {}

